const base = '/api-keys';

export const APIKeyUrl = {
  getZapierKey: `${base}/get-zapier-key`,
  createZapierKey: `${base}/create-zapier-key`,
  getWorkatoKey: `${base}/get-workato-key`,
  createWorkatoKey: `${base}/create-workato-key`,
  getRLApiKey: `${base}`,
  createRLApiKey: `${base}/create-for-user`,
  deleteRLApiKey: (id: number) => `${base}/${id}`,
  getJWTForAPIKey: (apiKey: string) => `${base}/${apiKey}/get-readme-token`,
  getHubspotKey: `${base}/get-hubspot-key`,
  createHubspotKey: `${base}/create-hubspot-key`,
};
